<template>
  <div class="component-page-header">
    <!-- {{ header }} -->
    <el-link icon="el-icon-s-home" :underline="false" href="#/index">
      {{ (header ? 'WES' : '') + (hubName ? "[" + hubName + "] " : "") + (username ? "(" + username + ")" : "") }}
    </el-link>
    <el-link style="margin-left: 20px" :underline="false" @click="showScanDialog">
      {{ username ? $t('base.change_user') : $t('base.scan_to_login') }}
    </el-link>

    <el-link v-if="username" style="margin-left: 20px" :underline="false" @click="showSupportDialog">
      {{ $t('base.add_support') }}
    </el-link>

    <span v-for="user in supportUsers" :key="user.username" class="support-user">
      <el-link :underline="false">{{ user.nickname || user.username }}</el-link>
      <i class="el-icon-close support-user-remove" @click="removeSupportUser(user)"></i>
    </span>

    <!-- 扫码登录弹窗 -->
    <div>
      <el-dialog
          :title="$t('base.scan_to_login')"
          :visible.sync="scan.showScanQrDialog"
          :modal="true"
          :modal-append-to-body="true"
          :append-to-body="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :center="true"
          width="400px"
      >
        <div>
          <el-input
              ref="scanQr"
              v-model="scan.qrcode"
              :placeholder="$t('base.please_scan_user_qr')"
              autocomplete="off"
              @keyup.enter.native="scanUserQr"
              @focus="focus($event)"
          ></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
              type="primary"
              @click="scanUserQr"
              :loading="scan.scanQrBtnLoading"
          >{{ $t("login.login") }}</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 添加支援人弹窗 -->
    <div>
      <el-dialog
          :title="$t('base.add_support')"
          :visible.sync="support.showDialog"
          :modal="true"
          :modal-append-to-body="true"
          :append-to-body="true"
          :close-on-click-modal="true"
          :close-on-press-escape="true"
          :center="true"
          width="500px"
      >
        <el-input
            v-model="support.searchKey"
            :placeholder="$t('base.find')"
            prefix-icon="el-icon-search"
            clearable
            style="margin-bottom: 12px"
        ></el-input>
        <el-table
            :data="filteredMemberList"
            v-loading="support.loading"
            max-height="400"
            size="small"
            style="width: 100%"
        >
          <el-table-column prop="username" label="Username" min-width="120"></el-table-column>
          <el-table-column prop="nickname" label="Nickname" min-width="120"></el-table-column>
          <el-table-column :label="$t('base.operation')" width="120" align="center">
            <template slot-scope="{ row }">
              <span v-if="isSupportUserSelected(row)" style="color: #909399; font-size: 12px">
                {{ $t('base.added') }}
              </span>
              <el-button
                  v-else
                  type="primary"
                  size="mini"
                  @click="addSupportUser(row)"
              >{{ $t('base.select') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.component-page-header /deep/ {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  line-height: 40px;
  padding: 0 10px;
  background: linear-gradient(to bottom, rgba(54, 108, 179, 0.4), #fff);

  .el-link {
    color: #444;
    font-size: 1.6rem;
    font-weight: bold;
  }

  .support-user {
    margin-left: 20px;
    white-space: nowrap;

    .support-user-remove {
      margin-left: 4px;
      font-size: 12px;
      color: #999;
      cursor: pointer;
      vertical-align: middle;

      &:hover {
        color: #f56c6c;
      }
    }
  }
}
</style>

<script>
import * as requestApi from '@/apis/auth';
import { getMemberListByHubId } from '@/apis/basic-action';

export default {
  props: {
    header: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: ''
    },
    hubName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      scan: {
        showScanQrDialog: false,
        qrcode: '',
        scanQrBtnLoading: false
      },
      support: {
        showDialog: false,
        memberList: [],
        searchKey: '',
        loading: false
      },
      supportUsers: []
    }
  },
  computed: {
    filteredMemberList() {
      const currentUser = sessionStorage.getItem('username')
      let list = this.support.memberList
      if (currentUser) {
        list = list.filter(m => m.username !== currentUser)
      }
      if (this.support.searchKey) {
        const key = this.support.searchKey.toLowerCase()
        list = list.filter(m =>
          (m.username && m.username.toLowerCase().includes(key)) ||
          (m.nickname && m.nickname.toLowerCase().includes(key))
        )
      }
      return list
    }
  },
  created() {
    this.loadSupportUsers()
  },
  methods: {
    focus(event) {
      event.target.select();
    },

    showScanDialog() {
      this.scan.showScanQrDialog = true;
      this.$nextTick(() => {
        this.$refs.scanQr.focus();
      });
    },

    scanUserQr() {
      console.log('Scan User Qr')
      this.scan.scanQrBtnLoading = true
      this.loading = true
      const data = {
        token_: this.scan.qrcode
      }

      requestApi.token2Login(data).then(rsp => {
        this.scan.qrcode = ''
        this.scan.showScanQrDialog = false
        this.loading = false
        this.scan.scanQrBtnLoading = false

        sessionStorage.setItem('username', rsp.username);
        sessionStorage.setItem('nickname', rsp.nickname);
        sessionStorage.setItem('token', rsp.token);
        sessionStorage.setItem('user', JSON.stringify(rsp));
        
        this.$localStorage.set('WES-TEXT-SELECT-FLAG', 1);
        let hub = rsp.hubList.filter(hub => hub.id === rsp.currentHubId)[0]
        this.$localStorage.set('label_check_before_each_order', hub.labelCheckFirstOfEachOrder)
        this.$localStorage.set('label_check_before_each_order_now', 0)
        this.$localStorage.set('label_check_by_each_label', hub.labelCheckOfEachLabel)
        this.$localStorage.set('label_check_by_each_label_now', 0)
        this.$localStorage.set('label_check_count_of_errors', hub.labelCheckCountOfError)
        this.$localStorage.set('label_check_count_of_errors_now', 0)
        location.reload();
      }).catch((error) => {
        this.$voice.playFail()
        this.scan.scanQrBtnLoading = false
        console.error(error)
      })
    },

    showSupportDialog() {
      this.support.showDialog = true
      this.support.searchKey = ''
      this.fetchMemberList()
    },

    fetchMemberList() {
      this.support.loading = true
      getMemberListByHubId().then(rsp => {
        let list = rsp
        if (list && !Array.isArray(list)) {
          list = list.list || list.records || list.data || Object.values(list)[0]
        }
        this.support.memberList = Array.isArray(list) ? list : []
      }).catch(err => {
        console.error('获取成员列表失败:', err)
        this.support.memberList = []
      }).finally(() => {
        this.support.loading = false
      })
    },

    isSupportUserSelected(user) {
      return this.supportUsers.some(u => u.username === user.username)
    },

    addSupportUser(user) {
      if (this.isSupportUserSelected(user)) return
      this.supportUsers.push({
        id: user.id || user.uid || user.userId,
        username: user.username,
        nickname: user.nickname
      })
      this.saveSupportUsers()
    },

    removeSupportUser(user) {
      this.supportUsers = this.supportUsers.filter(u => u.username !== user.username)
      this.saveSupportUsers()
    },

    saveSupportUsers() {
      sessionStorage.setItem('supportUsers', JSON.stringify(this.supportUsers))
    },

    loadSupportUsers() {
      try {
        const data = sessionStorage.getItem('supportUsers')
        this.supportUsers = data ? JSON.parse(data) : []
      } catch (e) {
        this.supportUsers = []
      }
    }
  }
}
</script>
